import ConfirmationModalBlock, { ConfirmationModalBlockProps } from './ConfirmationModalBlock';
import withInteractor from './ConfirmationModalBlock.interactor';
import withPresenter from './ConfirmationModalBlock.presenter';

export type { ConfirmationModalBlockProps };
export default withInteractor(withPresenter(ConfirmationModalBlock));
